// Spanish texts, keyed by the English text. One file per part of the app.
import { AGENTS_CHAT } from './agents_chat'
import { CAMERA } from './camera'
import { SHELL } from './shell'
import { SHELL_ROUTES } from './shell_routes'
import { SITE } from './site'

export const ES: Record<string, string> = {
  ...SHELL,
  ...SHELL_ROUTES,
  ...SITE,
  ...CAMERA,
  ...AGENTS_CHAT,
}
